export const SEARCH_BAR_DEFAULT_TEXT = 'Search for a location';
